import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Fase } from '../../_models/fase';
import { FaseService } from '../../_services/fase.service';

@Component( {
  selector: 'app-fase-listado',
  templateUrl: 'fase-listado.component.html'
} )

export class FaseListadoComponent implements OnInit {

  fases: Fase[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private fasServicio: FaseService,
               private navServicio: NavService,
               private router: Router,
               private autServicio: AutenticacionService ) {
  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/fases' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'FASES.LBL_CODIGO' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'FASES.LBL_FASE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'fases.component' );

    this.fasServicio.listado().subscribe( fases => {
      this.fases = fases;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear() {
    this.router.navigate( [ 'apl/fases/agregar' ] );
  }

  ver( fase: Fase ) {
    this.router.navigate( [ 'apl/fases/detalle/' + fase.idFase ] );
  }

  editar( fase: Fase ) {
    this.router.navigate( [ 'apl/fases/actualizar/' + fase.idFase ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'fases.component', this.busqueda );
  }
}
